export default __webpack_public_path__ + "static/media/insta.5be06074.png";